import React, { MouseEvent, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Tag } from '@maxtropy/components';

interface StatusButtonProps {
  checked?: boolean;
  onChange?: (event: MouseEvent, value: boolean) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const StatusButton: React.FC<StatusButtonProps> = ({ children, onChange, checked }) => {
  const [innerChecked, setChecked] = useState<boolean | undefined>();

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  const handleClick = (e: MouseEvent) => {
    setChecked(!innerChecked);
    onChange?.(e, !innerChecked);
  };

  return (
    <>
      <Tag border="solid" color={innerChecked ? 'info' : 'default'} style={{ marginLeft: 4 }} onClick={handleClick}>
        {children}
      </Tag>
    </>
  );
};

export default StatusButton;
